import { observer } from 'mobx-react';
import * as React from 'react';

import { EmailFormState, EmailActionResult } from '../../shared/email-form-state';
import { lazyInject } from '../../ioc';
import { LoginApiService } from 'src/api';
import { ResetEmailResponse } from 'src/api/model/resetEmailResponse';

import { ForgotPassword } from './desktop/forgot-password';

@observer
export class ForgotPasswordContainer extends React.Component {
    @lazyInject(LoginApiService) private loginApi!: LoginApiService;

    data = new EmailFormState((email) => this.resetEmail(email));

    async resetEmail(email: string): Promise<EmailActionResult> {
        const { data } = await this.loginApi.resetEmail({ email });
        return {
            message: this.getMessage(data, email),
            emailSent: data.success,
        };
    }

    private getMessage(response: ResetEmailResponse, email: string) {
        return response.success
            ? `A link to reset your password has been sent to ${email}`
            : 'Failed to send email';
    }

    render() {
        return <ForgotPassword container={this} />;
    }
}
